/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1LocationCountriesCountryidLangsId202,
  DeleteApiV1LocationCountriesCountryidLangsId401,
  DeleteApiV1LocationCountriesCountryidLangsId404,
  DeleteApiV1LocationCountriesCountryidLangsId500,
  DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
  DeleteApiV1LocationCountriesCountryidLangsIdPathParams,
} from "../../types/locationCountryLangController/DeleteApiV1LocationCountriesCountryidLangsId.ts";

export const deleteApiV1LocationCountriesCountryidLangsIdPathParamsSchema =
  z.object({
    countryId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1LocationCountriesCountryidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1LocationCountriesCountryidLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesCountryidLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1LocationCountriesCountryidLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesCountryidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1LocationCountriesCountryidLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesCountryidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1LocationCountriesCountryidLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCountriesCountryidLangsId500>;

export const deleteApiV1LocationCountriesCountryidLangsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1LocationCountriesCountryidLangsId202Schema,
  ) as unknown as ToZod<DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse>;
